export const report = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/report.jpg";
export const report1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/report1.jpg";
export const report2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/report2.jpg";
export const report3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/report3.jpg";

export const hetongS1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongS1.png";
export const hetongS2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongS2.png";


export const hetongJ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongJ1.png";
export const hetongJ2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongJ2.png";

export const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
export const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
export const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";

export const hetongW1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongW1.png";
export const hetongW2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongW2.png";
export const hetongG1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongG1.png";
export const hetongG2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongG2.png";